import { render, staticRenderFns } from "./GoalsWidget.vue?vue&type=template&id=a8f8c404"
import script from "./GoalsWidget.vue?vue&type=script&lang=js"
export * from "./GoalsWidget.vue?vue&type=script&lang=js"
import style0 from "./GoalsWidget.vue?vue&type=style&index=0&id=a8f8c404&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports